<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h1 class="toc-title">Table of Contents</h1>
<div class="img_container">
<img alt="images" src="images/fig1.jpg"/>
</div>
<h2 class="toc"><a href="#/xhtml/07_Acknowledgments">A<span class="small">CKNOWLEDGMENTS</span></a></h2>
<h2 class="toc"><a href="#/xhtml/08_Fm02">T<span class="small">OURING</span> R<span class="small">EVOLUTIONARY</span> W<span class="small">AR</span> C<span class="small">HARLESTON</span></a></h2>
<h2 class="toc"><a href="#/xhtml/09_Foreword#ch00">F<span class="small">OREWORD</span> <em class="italic">by Richard Hatcher III</em></a></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter01#ch01" title="Link target outside of Sample">C<span class="small">HAPTER</span> O<span class="small">NE</span>: The Allure of the South: The British Approach Charleston, 1776</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter02#ch02" title="Link target outside of Sample">C<span class="small">HAPTER</span> T<span class="small">WO</span>: Honor and Victory: The Battle of Sullivan’s Island, June 28, 1776</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter03#ch03" title="Link target outside of Sample">C<span class="small">HAPTER</span> T<span class="small">HREE</span>: Quiet Harbor, Charleston, 1776–1778</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter04#ch04" title="Link target outside of Sample">C<span class="small">HAPTER</span> F<span class="small">OUR</span>: We Will Fight It Out: The British Return to Charleston, 1779</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter05#ch05" title="Link target outside of Sample">C<span class="small">HAPTER</span> F<span class="small">IVE</span>: The British Advance on Charleston, February–March 1780</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter06#ch06" title="Link target outside of Sample">C<span class="small">HAPTER</span> S<span class="small">IX</span>: The Siege of Charleston, April–May 1780</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter07#ch07" title="Link target outside of Sample">C<span class="small">HAPTER</span> S<span class="small">EVEN</span>: The Surrender of Charleston, May 12, 1780</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter08#ch08" title="Link target outside of Sample">C<span class="small">HAPTER</span> E<span class="small">IGHT</span>: Occupied Charleston, 1780–1782</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter09#ch09" title="Link target outside of Sample">C<span class="small">HAPTER</span> N<span class="small">INE</span>: Charleston Liberated, December 14, 1782</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Appendix01#ch10" title="Link target outside of Sample">A<span class="small">PPENDIX</span> A: George Washington Visits Charleston</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Appendix02#ch11" title="Link target outside of Sample">A<span class="small">PPENDIX</span> B: Revolutionary War Charleston in American Memory</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Order" title="Link target outside of Sample">Order of Battle</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Reading" title="Link target outside of Sample">Suggested Reading</span></h2>
<h2 class="toc"><span href="#/xhtml/24_About" title="Link target outside of Sample">About the Author</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?66eb0d32